import React from 'react';
export function Guarantee() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-cream" data-id="element-67">
      <div className="max-w-xl mx-auto" data-id="element-68">
        <div className="bg-white border border-brand-gold/40 p-6 sm:p-8 rounded-2xl text-center" data-id="element-69">
          <h3 className="text-lg sm:text-2xl font-serif font-bold text-brand-text-main mb-3 sm:mb-4" data-id="element-70">
            🛡️ GARANZIA DI FERRO: 7 GIORNI O RIMBORSATA.
          </h3>
          <p className="text-xs sm:text-sm text-brand-text-muted font-medium leading-relaxed" data-id="element-71">
            Prova il sistema Reset Mediterraneo™. Se nei primi 7 giorni non
            senti la pancia più piatta, la mente più lucida e la tua vita più
            organizzata, ti rimborsiamo ogni centesimo. Senza domande. Il
            rischio è nostro, il risultato è tuo.
          </p>
        </div>
      </div>
    </section>;
}